module.exports = __webpack_public_path__ + "components/MapControl/svg/Inny obiekt kultu religijnego.svg?77ed19d3";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Inny obiekt kultu religijnego.svg
// module id = 1976
// module chunks = 0